import { ListType } from '../constants';
import { editableListInitialStateFactory, editableListReducerFactory } from '../reducers';
import { compareValueText, findModifiedText, getModifiedText, getPersistedText, updatePersistedTextValue } from './selectors';
import { ModifiedText, TextListMetadata, TextListValidationError, TextSearchData, TextSearchModel } from './types-store';
import { removeValidationForText } from './validation';

export const textConfigurationListState = editableListInitialStateFactory<
  TextListMetadata, TextSearchData, ModifiedText, TextSearchModel, TextListValidationError
>();

export const textConfigurationListReducer = editableListReducerFactory<
  TextListMetadata, TextSearchData, ModifiedText, TextSearchModel, TextListValidationError
>(
  ListType.text,
  textConfigurationListState,
  getModifiedText,
  findModifiedText,
  getPersistedText,
  compareValueText,
  updatePersistedTextValue,
  removeValidationForText
);
